import {Poly} from '../../../@polygonjs/polygonjs/src/engine/Poly';
import {TypeAssert} from '../../../@polygonjs/polygonjs/src/engine/poly/Assert';
import {ModuleName} from '../../../@polygonjs/polygonjs/src/engine/poly/registers/modules/Common';

export class FilesRegister {
	protected static _polygonjs: string;
	protected static _polygonjsLicense: string;
	protected static _moduleContentByName: Map<ModuleName, string> = new Map();
	protected static _moduleLicenseContentByName: Map<ModuleName, string> = new Map();
	protected static _thumbnailStaticBlob: Blob | undefined;

	static async init() {
		// @ts-ignore
		const POLYGONJS = await import('raw-loader!../../../@polygonjs/polygonjs/dist/all.js');
		this._polygonjs = (POLYGONJS as any).default;
		// @ts-ignore
		const POLYGONJS_LICENSE = await import('raw-loader!../../../@polygonjs/polygonjs/dist/all.js.LICENSE.txt');
		this._polygonjsLicense = (POLYGONJS_LICENSE as any).default;

		const moduleNames = Poly.modulesRegister.moduleNames();
		for (let moduleName of moduleNames) {
			// const moduleContent = await import(
			// 	// @ts-ignore
			// 	`raw-loader!../../../@polygonjs/polygonjs/dist/modules/${moduleName}.js`
			// );
			const moduleContent = await this._importModuleContent(moduleName);
			this._moduleContentByName.set(moduleName, (moduleContent as any).default);

			// try {
			// const moduleLicenseContent = await import(
			// 	// @ts-ignore
			// 	`raw-loader!../../../@polygonjs/polygonjs/dist/modules/${moduleName}.js.LICENSE.txt`
			// );
			const moduleLicenseContent = await this._importModuleLicense(moduleName);
			if (moduleLicenseContent && (moduleLicenseContent as any).default) {
				this._moduleLicenseContentByName.set(moduleName, (moduleLicenseContent as any).default);
			}
			// } catch (err) {}
		}

		this._loadThumbnailstaticBlob();
	}

	private static _polyConfig: string | undefined;
	static polyConfig() {
		return this._polyConfig;
	}
	static async registerPolyConfig(url: string) {
		const response = await fetch(url);
		const text = await response.text();
		this._polyConfig = text;
	}

	private static _importModuleContent(moduleName: ModuleName) {
		switch (moduleName) {
			case ModuleName.BasisTextureLoader: {
				// @ts-ignore
				return import(`raw-loader!../../../@polygonjs/polygonjs/dist/modules/BasisTextureLoader.js`);
			}
			case ModuleName.DRACOLoader: {
				// @ts-ignore
				return import(`raw-loader!../../../@polygonjs/polygonjs/dist/modules/DRACOLoader.js`);
			}
			case ModuleName.EXRLoader: {
				// @ts-ignore
				return import(`raw-loader!../../../@polygonjs/polygonjs/dist/modules/EXRLoader.js`);
			}
			case ModuleName.FBXLoader: {
				// @ts-ignore
				return import(`raw-loader!../../../@polygonjs/polygonjs/dist/modules/FBXLoader.js`);
			}
			case ModuleName.GLTFLoader: {
				// @ts-ignore
				return import(`raw-loader!../../../@polygonjs/polygonjs/dist/modules/GLTFLoader.js`);
			}
			case ModuleName.OBJLoader: {
				// @ts-ignore
				return import(`raw-loader!../../../@polygonjs/polygonjs/dist/modules/OBJLoader.js`);
			}
			case ModuleName.PDBLoader: {
				// @ts-ignore
				return import(`raw-loader!../../../@polygonjs/polygonjs/dist/modules/PDBLoader.js`);
			}
			case ModuleName.PLYLoader: {
				// @ts-ignore
				return import(`raw-loader!../../../@polygonjs/polygonjs/dist/modules/PLYLoader.js`);
			}
			case ModuleName.RGBELoader: {
				// @ts-ignore
				return import(`raw-loader!../../../@polygonjs/polygonjs/dist/modules/RGBELoader.js`);
			}
			case ModuleName.SVGLoader: {
				// @ts-ignore
				return import(`raw-loader!../../../@polygonjs/polygonjs/dist/modules/SVGLoader.js`);
			}
			case ModuleName.STLLoader: {
				// @ts-ignore
				return import(`raw-loader!../../../@polygonjs/polygonjs/dist/modules/STLLoader.js`);
			}
			case ModuleName.TTFLoader: {
				// @ts-ignore
				return import(`raw-loader!../../../@polygonjs/polygonjs/dist/modules/TTFLoader.js`);
			}
		}
		TypeAssert.unreachable(moduleName);
	}
	private static _importModuleLicense(moduleName: ModuleName) {
		switch (moduleName) {
			case ModuleName.BasisTextureLoader: {
				return null;
			}
			case ModuleName.DRACOLoader: {
				return null;
			}
			case ModuleName.EXRLoader: {
				// @ts-ignore
				return import(`raw-loader!../../../@polygonjs/polygonjs/dist/modules/EXRLoader.js.LICENSE.txt`);
			}
			case ModuleName.FBXLoader: {
				// @ts-ignore
				return import(`raw-loader!../../../@polygonjs/polygonjs/dist/modules/FBXLoader.js.LICENSE.txt`);
			}
			case ModuleName.GLTFLoader: {
				return null;
			}
			case ModuleName.OBJLoader: {
				return null;
			}
			case ModuleName.PDBLoader: {
				return null;
			}
			case ModuleName.PLYLoader: {
				return null;
			}
			case ModuleName.RGBELoader: {
				return null;
			}
			case ModuleName.SVGLoader: {
				return null;
			}
			case ModuleName.STLLoader: {
				return null;
			}
			case ModuleName.TTFLoader: {
				// @ts-ignore
				return import(`raw-loader!../../../@polygonjs/polygonjs/dist/modules/TTFLoader.js.LICENSE.txt`);
			}
		}
		TypeAssert.unreachable(moduleName);
	}

	static polygonjs() {
		return this._polygonjs;
	}
	static polygonjsLicense() {
		return this._polygonjsLicense;
	}
	static module(moduleName: ModuleName) {
		return this._moduleContentByName.get(moduleName);
	}
	static moduleLicense(moduleName: ModuleName) {
		return this._moduleLicenseContentByName.get(moduleName);
	}

	//
	//
	// THUMBNAIL STATIC BLOB
	//
	//
	private static async _loadThumbnailstaticBlob() {
		const elementId = 'thumbnail_static_for_self_contained_export';
		const image = document.getElementById(elementId) as HTMLImageElement;
		if (!image) {
			return;
		}
		const url = image.src;
		const response = await fetch(url);
		const blob = await response.blob();
		this.setThumbnailStaticBlob(blob);
	}
	static setThumbnailStaticBlob(blob: Blob) {
		this._thumbnailStaticBlob = blob;
	}
	static thumbnailStaticBlob() {
		return this._thumbnailStaticBlob;
	}
}
